import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';
import { Router } from '@angular/router';
import { MaterialModule } from 'src/app/material.module';
import { tasksServices } from 'src/app/services/tasks.service';
import { firstValueFrom, take } from 'rxjs';
import { EventConfirmationDialogComponent } from '../calendar/event-confirmation-dialog/event-confirmation-dialog.component';
import { NotificationTypeEnum } from 'src/app/leads/interface-data/data';
import { DialogComponent } from '../dialog/confirm.dialog';
import { environment } from 'src/environments/environment';
import { SocketService } from 'src/app/services/socket.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-notification-snack',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './notification-snack.component.html',
  styleUrl: './notification-snack.component.scss'
})
export class NotificationSnackComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private snackBarRef: MatSnackBarRef<NotificationSnackComponent>,
    private taskService: tasksServices,
    public router: Router,
    private dialog: MatDialog,
    private notificationService:SocketService,
    private bottomSheet: MatBottomSheet  // Add this
  ) {
  }

  async onClick() {
    // let snackbar close first
    this.snackBarRef.dismiss();
  
    // move the rest to the next macrotask so the current CD finishes
    setTimeout(async () => {
      // 1) close every dialog
      this.dialog.closeAll();

      this.bottomSheet.dismiss();
  
      // 2) WAIT until all dialogs are fully destroyed
      await firstValueFrom(this.dialog.afterAllClosed.pipe(take(1)));
  
      // 3) the rest of your current logic (unchanged)
      const isInbox = this.data.message?.notification?.type == NotificationTypeEnum.Message;
      if (!this.data.message?.notification?.seen) {
        await firstValueFrom(this.notificationService.patch({}, this.data.message?.notification?.id));
        if (isInbox) this.notificationService.decrementInbox(); else this.notificationService.decrement();
      }
  
      if (this.data.message?.notification?.disableLink) {
        const header = this.data.message?.notification?.title || 'Notification from Automation module';
        const body = this.data.message?.notification?.body;
        await this.showNotificationDialog(header, body, true, '700px', 'info');
        return;
      } else if (
        this.data.message?.notification?.type == NotificationTypeEnum.IMPORT_SUCCSESS ||
        this.data.message?.notification?.type == NotificationTypeEnum.GROUP_MESSAGE_SUCCESSFULLY
      ) {
        const header = this.data.message?.notification?.title;
        const body = this.data.message?.notification?.body;
        await this.showNotificationDialog(header, body, true, '700px', 'info');
        return;
      }
  
      if (this.data.message?.notification?.type == 'Activity') {
        this.router.navigate(['/activities/list'], {
          queryParams: { activity_id: this.data.message?.notification.record_id }
        });
      } else if (this.data.message?.notification?.type == NotificationTypeEnum.IMPORT_FAILED) {
        const header = `${this.data.message?.notification?.title}`;
        const body =
          'We encountered errors during the import process. Click Download to view the Excel file with highlighted error rows and detailed comments about the issues.';
        const allowDownload = await this.showNotificationDialog(header, body, false, '700px', 'error', 'Download');
        if (allowDownload) {
          const url = `${environment.publicCloudFlareUrl}/excel-reports/${this.data.message?.notification?.urlLink}`;
          window.open(url, '_blank');
        }
      } else if (this.data.message?.notification?.type == NotificationTypeEnum.GROUP_MESSAGE_SOME_FAILED) {
        const header = `${this.data.message?.notification?.title}`;
        const body = 'Some group messages failed to send. Please click "Download" to view the detailed report.';
        const allowDownload = await this.showNotificationDialog(header, body, false, '700px', 'error', 'Download');
        if (allowDownload) {
          const url = `${environment.publicCloudFlareUrl}/excel-reports/${this.data.message?.notification?.urlLink}`;
          window.open(url, '_blank');
        }
      } else {
        const targetUrl = `/leads/leads-managment/manage/${this.data.message?.notification.record_id}`;
        const user = JSON.parse(localStorage.getItem('userData') || '{}');
        const enableCalls = user?.Company?.enable_calls ?? false;
        let tab = this.data.message?.notification.type === NotificationTypeEnum.UploadDocuments ? (enableCalls ? 4 : 3) : 0;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([targetUrl], { queryParams: { section: tab }, queryParamsHandling: 'merge' });
        });
      }
    }, 0);
  }
  

  close(event) {
    event.stopPropagation();
    this.snackBarRef.dismiss();
  }

  showNotificationDialog(header: string, content: string, isInfo = false, width = '500px',type='info',buttonName='') {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: {
        header,
        content,
        isInfo,
        type,
        buttonName
      },
      width,
    });

    return dialogRef.afterClosed().toPromise();
  }
}